export default __webpack_public_path__ + "static/media/Jumbroton-Illustration.80568064.png";